import React from 'react';
import { remCalc } from 'util/style-util';
import hwtLogoPath from 'assets/images/hitt-logo-round.png';
import closeBtnPath from 'assets/images/close-button.svg';
import { translate } from 'translations/translator';
import { FONT_GSS_FUTURA } from 'themes/default';
import WebLink from 'components/@common/WebLink';
import { makeStyles } from '@mui/styles';
const translateResources = key => translate('resources', key);

type Props = {
  show: boolean;
  onClose: () => void;
};

function ExpiredLicenseAlert(props: Props) {
  const { alertContainer, alertContent, alertImg, alertText, closeBtn, closeImg } = useStyles();

  return props.show ? (
    <div className={alertContainer}>
      <div className={alertContent}>
        <img src={hwtLogoPath} alt="PreKITT Logo" className={alertImg} />
        <span className={alertText}>
          {translateResources('clickAwayOnly')}
          <WebLink
            style={{ textDecoration: 'underline' }}
            to="https://www.lwtears.com/IDTT"
            target="_blank"
            name={translateResources('clickAwayBuyLink')}
          />
        </span>
      </div>

      <button type="button" className={closeBtn} onClick={props.onClose}>
        <img src={closeBtnPath} alt="closeBtn" className={closeImg} />
      </button>
    </div>
  ) : null;
}

const useStyles = makeStyles(() => ({
  alertContainer: {
    display: 'flex',
    width: '100%',
    backgroundColor: '#e7e7e7',
    alignItems: 'center',
    justifyContent: 'center',
    position: 'relative'
  },
  alertContent: {
    padding: remCalc(10),
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  alertImg: {
    width: remCalc(50),
    paddingRight: remCalc(10)
  },
  closeBtn: {
    border: 'none',
    backgroundColor: '#e7e7e7',
    position: 'absolute',
    right: 0
  },
  closeImg: {
    width: remCalc(25)
  },
  alertText: {
    fontFamily: FONT_GSS_FUTURA,
    fontStyle: 'normal',
    fontWeight: 300,
    fontSize: remCalc(18),
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    width: '100%',
    maxHeight: remCalc(77)
  },
  link: {
    paddingLeft: remCalc(5),
    fontWeight: '500'
  }
}));

export default ExpiredLicenseAlert;
